/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Yoast AI Brand Insights API
 * API for AI-powered brand insights and analysis
 * OpenAPI spec version: 1.0.0
 */
export type AIProviderEnum =
  (typeof AIProviderEnum)[keyof typeof AIProviderEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AIProviderEnum = {
  openai: 'openai',
  perplexity: 'perplexity',
  anthropic: 'anthropic',
} as const;

export type LanguageEnum = (typeof LanguageEnum)[keyof typeof LanguageEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LanguageEnum = {
  en: 'en',
  zh: 'zh',
  es: 'es',
  hi: 'hi',
  ar: 'ar',
  pt: 'pt',
  fr: 'fr',
  ru: 'ru',
  de: 'de',
  ja: 'ja',
  ko: 'ko',
  it: 'it',
  nl: 'nl',
  tr: 'tr',
  pl: 'pl',
  sv: 'sv',
  no: 'no',
  da: 'da',
  fi: 'fi',
  th: 'th',
} as const;

export type BrandStatusEnum =
  (typeof BrandStatusEnum)[keyof typeof BrandStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrandStatusEnum = {
  pendingQuerySelection: 'pendingQuerySelection',
  scheduledFirstAnalysis: 'scheduledFirstAnalysis',
  firstAnalysisInProgress: 'firstAnalysisInProgress',
  completed: 'completed',
} as const;

/**
 * Categories for citation sources
 */
export type CitationCategoryEnum =
  (typeof CitationCategoryEnum)[keyof typeof CitationCategoryEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CitationCategoryEnum = {
  Publisher: 'Publisher',
  Social_media: 'Social media',
  Business: 'Business',
  Other: 'Other',
} as const;

/**
 * Impact levels for citation sources
 */
export type CitationImpactEnum =
  (typeof CitationImpactEnum)[keyof typeof CitationImpactEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CitationImpactEnum = {
  Low: 'Low',
  Medium: 'Medium',
  High: 'High',
} as const;

/**
 * Universally Unique Lexicographically Sortable Identifier
 */
export type Ulid = string;

/**
 * Generic URL field
 */
export type Url = string;

/**
 * Percentage value
 * @minimum 0
 * @maximum 100
 */
export type Percentage = number;

/**
 * @minLength 1
 * @maxLength 255
 */
export type BrandName = string;

/**
 * @minLength 1
 * @maxLength 255
 */
export type BrandDescription = string;

export type BrandUrl = Url;

export type Country = (typeof Country)[keyof typeof Country];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Country = {
  US: 'US',
  CN: 'CN',
  JP: 'JP',
  DE: 'DE',
  IN: 'IN',
  GB: 'GB',
  FR: 'FR',
  IT: 'IT',
  BR: 'BR',
  CA: 'CA',
  RU: 'RU',
  KR: 'KR',
  ES: 'ES',
  AU: 'AU',
  MX: 'MX',
  ID: 'ID',
  NL: 'NL',
  SA: 'SA',
  TR: 'TR',
  TW: 'TW',
  BE: 'BE',
  PL: 'PL',
  AR: 'AR',
  IE: 'IE',
  IL: 'IL',
  TH: 'TH',
  NG: 'NG',
  EG: 'EG',
  ZA: 'ZA',
  SE: 'SE',
  OTHER: 'OTHER',
} as const;

export type Region = string;

export type DateTime = string;

/**
 * @minimum 0
 */
export type Count = number;

export type ChartDataDatasetsItem = {
  label: string;
  data: number[];
};

/**
 * Generic chart data structure with labels and corresponding data points for graphing purposes
 */
export interface ChartData {
  labels: string[];
  datasets: ChartDataDatasetsItem[];
}

export type ScoreValue = number | Percentage;

/**
 * Comparison of current score with a previous score
 */
export interface ScoreComparison {
  value: ScoreValue;
  difference: number;
  /**
   * Percentage change from the previous score to the current score. Null if previous score was zero.
   * @nullable
   */
  percentageChange: number | null;
}

/**
 * @nullable
 */
export type ScorePrevious = ScoreComparison | null;

export interface Score {
  value: ScoreValue;
  /** @nullable */
  previous?: ScorePrevious;
}

export type ScoresStandardized = {
  visibility: Score;
  mentions: Score;
  ranking: Score;
  citations: Score;
  sentiment: Score;
};

/**
 * Detailed scoring information for scan results
 */
export interface Scores {
  standardized?: ScoresStandardized;
}

export type QueryMentionScoreQueriesWithMentionsItemAllOf = {
  /** Whether the own brand was mentioned in the query result */
  mentioned: boolean;
};

export type QueryMentionScoreQueriesWithMentionsItem = QueryObject &
  QueryMentionScoreQueriesWithMentionsItemAllOf;

/**
 * Array of query objects indicating if the own brand was mentioned in the results for each query
 */
export interface QueryMentionScore {
  mentionedInNumberOfQueries: Score;
  chart: ChartData;
  queriesWithMentions: QueryMentionScoreQueriesWithMentionsItem[];
}

export type RankScoreListItemBrand = {
  name: BrandName;
  numberOfMentions: Score;
  /** Indicates if this brand is the user's own brand */
  isSelf: boolean;
};

export type RankScoreListItem = {
  id: Ulid;
  rank: Score;
  brand: RankScoreListItemBrand;
};

/**
 * Rank of your own and competitor's brands in the AI results
 */
export interface RankScore {
  list: RankScoreListItem[];
}

export type CitationScoreListItem = {
  url: Url;
  rootDomain: string;
  category: CitationCategoryEnum;
  impact: CitationImpactEnum;
  numberOfMentions: Score;
};

/**
 * The result of the citations analysis for a scan. Tracks which sources were cited by the AI in the results.
 */
export interface CitationScore {
  total: Score;
  categories: CitationCategoryEnum[];
  list: CitationScoreListItem[];
}

export type SentimentScoreKeywords = {
  positive: string[];
  negative: string[];
};

/**
 * The sentiment analysis result for a scan for a brand
 */
export interface SentimentScore {
  brandName: BrandName;
  positivityPercentage: Score;
  keywords: SentimentScoreKeywords;
}

/**
 * @nullable
 */
export type SentimentScoresOwn = SentimentScore | null;

/**
 * @nullable
 */
export type SentimentScoresTopCompetitor = SentimentScore | null;

/**
 * Sentiment scores for your brand and your top competitor
 */
export interface SentimentScores {
  /** @nullable */
  own: SentimentScoresOwn;
  /** @nullable */
  topCompetitor: SentimentScoresTopCompetitor;
}

export type ScanId = Ulid;

export type ScanStatus = (typeof ScanStatus)[keyof typeof ScanStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScanStatus = {
  pending: 'pending',
  in_progress: 'in_progress',
  completed: 'completed',
  updating: 'updating',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;

/**
 * @nullable
 */
export type ScanFinishedAt = DateTime | null;

/**
 * Detailed scan object with all properties
 */
export interface Scan {
  id: Ulid;
  aiProvider?: AIProviderEnum;
  status: ScanStatus;
  startedAt: DateTime;
  /** @nullable */
  finishedAt: ScanFinishedAt;
  /** Indicates if the scan is up to date with the current brand group associations. When this is false, the results may not be reliable until the scan is updated. Recent scans are automatically updated in the background. */
  isUpToDateWithBrandGroups: boolean;
  scores?: Scores;
  numberOfQueries?: Count;
  mentions?: QueryMentionScore;
  citations?: CitationScore;
  rankings?: RankScore;
  sentiment?: SentimentScores;
}

export type AnalysisId = Ulid;

export type AnalysisStatus =
  (typeof AnalysisStatus)[keyof typeof AnalysisStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalysisStatus = {
  pending: 'pending',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;

/**
 * @nullable
 */
export type AnalysisBaseStatus = AnalysisStatus | null;

/**
 * Core analysis properties shared across all analysis representations
 */
export interface AnalysisBase {
  id: Ulid;
  /** @nullable */
  status?: AnalysisBaseStatus;
  aiviScore: Score;
  createdAt: DateTime;
  completedAt: DateTime;
}

export type AnalysisDetailedAllOf = {
  scans: Scan[];
};

/**
 * Complete analysis object with full data and scoring
 */
export type AnalysisDetailed = AnalysisBase & AnalysisDetailedAllOf;

/**
 * An analysis identifier or the string literal "latest"
 */
export type AnalysisIdOrLatest = string | 'latest';

/**
 * @minLength 3
 * @maxLength 500
 */
export type Query = string;

/**
 * Array of query strings
 */
export type Queries = Query[];

export type QueryId = Ulid;

/**
 * Detailed query object with ID and query string
 */
export interface QueryObject {
  id: Ulid;
  query: Query;
}

/**
 * Array of detailed query objects
 */
export type QueryObjects = QueryObject[];

export type AssociatedBrandId = Ulid;

export type AssociatedBrandGroupId = Ulid;

/**
 * Request to create a brand association group
 */
export interface BrandAssociationRequest {
  groupName: string;
  brandIds: Ulid[];
}

/**
 * Request to update properties of an associated brand
 */
export interface AssociatedBrandUpdateRequest {
  isHidden?: boolean;
}

export type AssociatedBrandsResponseAssociatedBrandsItem =
  | UngroupedAssociatedBrand
  | GroupedAssociatedBrand;

/**
 * Response containing associated brands data
 */
export interface AssociatedBrandsResponse {
  associatedBrands: AssociatedBrandsResponseAssociatedBrandsItem[];
}

export type UngroupedAssociatedBrandType =
  (typeof UngroupedAssociatedBrandType)[keyof typeof UngroupedAssociatedBrandType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UngroupedAssociatedBrandType = {
  item: 'item',
} as const;

/**
 * Represents an associated brand that is not part of any group
 */
export interface UngroupedAssociatedBrand {
  type: UngroupedAssociatedBrandType;
  id: Ulid;
  name: string;
  isHidden: boolean;
  /** Indicates if this brand is the user's own brand */
  isSelf: boolean;
}

export type GroupedAssociatedBrandType =
  (typeof GroupedAssociatedBrandType)[keyof typeof GroupedAssociatedBrandType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GroupedAssociatedBrandType = {
  group: 'group',
} as const;

/**
 * Represents an associated brand that is part of a group
 */
export interface GroupedAssociatedBrand {
  type: GroupedAssociatedBrandType;
  id: Ulid;
  name: string;
  isHidden: boolean;
  /** Indicates if this group is owned by the user */
  isSelf: boolean;
  groupedBrands: UngroupedAssociatedBrand[];
}

/**
 * Settings related to a brand
 */
export interface BrandSettings {
  enableAutomaticAnalysis: boolean;
  enableNotifications: boolean;
  createdAt: DateTime;
  updatedAt: DateTime;
}

/**
 * Only the setting values without the rest of the model properties
 */
export interface BrandSettingValues {
  enableAutomaticAnalysis?: boolean;
  enableNotifications?: boolean;
  showAutomaticAnalysisDisabledNotification?: boolean;
}

export type UserId = Ulid;

/**
 * User information
 */
export interface User {
  id?: Ulid;
  /**
   * @minLength 1
   * @maxLength 100
   */
  displayName?: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  firstName?: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  lastName?: string;
  email?: string;
}

/**
 * Response containing user and their brands
 */
export interface UserResponse {
  user?: User;
  brands?: Brand[];
}

export type BrandId = Ulid;

/**
 * @nullable
 */
export type BrandUrlProperty = Url | null;

/**
 * @nullable
 */
export type BrandCountry = Country | null;

/**
 * @nullable
 */
export type BrandRegionOrCity = Region | null;

/**
 * @nullable
 */
export type BrandNextScheduledAnalysis = DateTime | null;

/**
 * @nullable
 */
export type BrandFirstNextAnalysisOpportunity = DateTime | null;

/**
 * Complete brand object with all properties
 */
export interface Brand {
  id: Ulid;
  name: BrandName;
  /** @nullable */
  url: BrandUrlProperty;
  description: BrandDescription;
  focusLanguage: LanguageEnum;
  /** @nullable */
  country?: BrandCountry;
  /** @nullable */
  regionOrCity?: BrandRegionOrCity;
  setupStatus: BrandStatusEnum;
  /** @nullable */
  nextScheduledAnalysis?: BrandNextScheduledAnalysis;
  /** @nullable */
  firstNextAnalysisOpportunity?: BrandFirstNextAnalysisOpportunity;
  createdAt: DateTime;
}

export type BrandsBrandsItemAllOf = {
  settings: BrandSettingValues;
};

export type BrandsBrandsItem = Brand & BrandsBrandsItemAllOf;

/**
 * A list of brands
 */
export interface Brands {
  brands: BrandsBrandsItem[];
}

export type BrandDetailedAllOf = {
  queries: QueryObjects;
};

/**
 * Extended brand object with lifecycle and summary information
 */
export type BrandDetailed = Brand & BrandDetailedAllOf;

/**
 * @nullable
 */
export type BrandCreateUrl = Url | null;

/**
 * @nullable
 */
export type BrandCreateCountry = Country | null;

/**
 * @nullable
 */
export type BrandCreateRegionOrCity = Region | null;

/**
 * Brand object for creation requests (without id and createdAt)
 */
export interface BrandCreate {
  name: BrandName;
  /** @nullable */
  url?: BrandCreateUrl;
  description: BrandDescription;
  focusLanguage: LanguageEnum;
  /** @nullable */
  country?: BrandCreateCountry;
  /** @nullable */
  regionOrCity?: BrandCreateRegionOrCity;
}

/**
 * Standard error response format
 */
export interface ErrorResponse {
  error?: string;
}

/**
 * An object containing a success message
 */
export interface SuccessMessage {
  message?: string;
}

/**
 * @nullable
 */
export type ValidationErrorErrors = { [key: string]: unknown } | null;

/**
 * Validation error response
 */
export interface ValidationError {
  message?: string;
  /** @nullable */
  errors?: ValidationErrorErrors;
}

/**
 * Resource not found error response
 */
export interface NotFoundError {
  error?: string;
}

/**
 * Unauthenticated or unauthorized access error response
 */
export interface UnauthorizedError {
  error?: string;
}

/**
 * Payment required error response
 */
export interface PaymentRequiredError {
  error?: string;
}

/**
 * Forbidden access error response
 */
export interface ForbiddenError {
  error?: string;
}

/**
 * Success response containing message and data
 */
export interface SuccessResponseWithData {
  /** Success message */
  message?: string;
  /** Response data (varies by endpoint) */
  data?: unknown;
}

/**
 * The operation was successful
 */
export type SuccessMessageResponse = SuccessMessage;

/**
 * The request data was invalid
 */
export type ValidationErrorResponse = ValidationError;

/**
 * Something's wrong with the request. Repeating this request will not yield a different result. Check the error message for details.
 */
export type BadRequestResponse = ErrorResponse;

/**
 * No or invalid credentials provided for the requested route
 */
export type UnauthorizedResponse = UnauthorizedError;

/**
 * Payment required to access this resource or perform this action
 */
export type PaymentRequiredResponse = PaymentRequiredError;

/**
 * Forbidden
 */
export type ForbiddenResponse = ForbiddenError;

/**
 * Resource not found
 */
export type NotFoundResponse = NotFoundError;

export type GetAnalysisList200 = {
  analyses: AnalysisBase[];
};

export type PostAnalysisBody = {
  providers: AIProviderEnum[];
};

export type PostAnalysis201 = {
  analysis: AnalysisBase;
};

export type DeleteAnalysis200 = {
  message: string;
  deleted_count: number;
};

export type GetAnalysis200 = {
  analysis: AnalysisDetailed;
};

export type DeleteSingleAnalysis200 = {
  message: string;
};

export type GetAnalysisStatus200 = {
  id: Ulid;
  status: AnalysisStatus;
  completedQueries: Ulid[];
};

export type LoginBody = {
  email: string;
  password: string;
};

export type Login200DataUser = {
  id?: Ulid;
  name?: string;
  email?: string;
  created_at?: string;
  updated_at?: string;
};

export type Login200Data = {
  user?: Login200DataUser;
};

export type Login200 = {
  data?: Login200Data;
  message?: string;
};

export type Login401 = {
  message?: string;
};

export type GetToken200AccessToken = {
  name: string;
  abilities: string[];
  expires_at: DateTime;
};

export type GetToken200 = {
  plainTextToken: string;
  accessToken: GetToken200AccessToken;
};

export type RegisterBody = {
  name: string;
  email: string;
  password: string;
  password_confirmation: string;
};

export type Register201DataUser = {
  id?: Ulid;
  name?: string;
  email?: string;
  created_at?: string;
  updated_at?: string;
};

export type Register201Data = {
  user?: Register201DataUser;
};

export type Register201 = {
  data?: Register201Data;
  message?: string;
};

export type Register422Errors = { [key: string]: unknown };

export type Register422 = {
  message?: string;
  errors?: Register422Errors;
};

export type Logout200 = {
  message?: string;
};

export type Logout401 = {
  message?: string;
};

export type CreateBrandAssociationGroup400 = {
  error?: string;
};

export type DeleteBrandAssociationGroup400 = {
  error?: string;
};

export type GetBrandQueries200 = {
  queries: QueryObjects;
};

export type UpdateBrandQueriesBody = {
  queries: Queries;
};

export type UpdateBrandQueries200 = {
  message: string;
  queries: QueryObjects;
};

export type UpdateBrandQueries400 = {
  error: string;
};

export type GetQuerySuggestions200 = {
  queries: Queries;
};

export type GetCurrentUser200Data = {
  /** @pattern ^usr_[a-z0-9]{9}$ */
  id?: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  displayName?: string;
  email?: string;
};

export type GetCurrentUser200BrandsItemStatus =
  (typeof GetCurrentUser200BrandsItemStatus)[keyof typeof GetCurrentUser200BrandsItemStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCurrentUser200BrandsItemStatus = {
  pendingSetup: 'pendingSetup',
  pendingQuerySelection: 'pendingQuerySelection',
  pendingBrandGrouping: 'pendingBrandGrouping',
  active: 'active',
  deleting: 'deleting',
  deleted: 'deleted',
} as const;

export type GetCurrentUser200BrandsItem = {
  id?: string;
  name?: string;
  status?: GetCurrentUser200BrandsItemStatus;
  lastAnalysisDate?: string;
  /** @minimum 0 */
  analysisCount?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  currentScore?: number;
};

export type GetCurrentUser200 = {
  data?: GetCurrentUser200Data;
  /** @minimum 0 */
  activeSubscriptions?: number;
  /** @minimum 0 */
  maxNumberOfActiveBrands?: number;
  /** @minimum 0 */
  numberOfActiveBrands?: number;
  brands?: GetCurrentUser200BrandsItem[];
};
